import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useAppDataSliceSelector } from '../store/modules/appData';
import { openDialog } from '../store/modules/dialog';
import {
  DIALOG_TYPE,
  DOCUMENT_TYPE,
  DOC_FORMAT_CONFIG_VALUES,
  EDIT_FROM,
  PRODUCT_TYPE,
  URLS
} from '../define/global';
import { NAVERWORKS_NAVIGATOR_TYPE } from '../define/naverworksDefine';
// import IconVote from '../img/activeLink/ribbonIcon/ribbon_big_ico_form.png';
// import IconImageLayout from '../img/activeLink/ribbonIcon/ribbon_big_ico_imagelayout.png';
// import IconSeatPosition from '../img/activeLink/ribbonIcon/ribbon_big_ico_seatposition.png';
import IconITTContents from '../img/activeLink/ribbonIcon/ribbon_big_ico_toktokcon.png';
import IconYoutube from '../img/activeLink/ribbonIcon/ribbon_big_ico_youtube.png';
import IconCollaboration from '../img/activeLink/ribbonIcon/ribbon_big_ico_canvers_beta.png';
import IconMap from '../img/activeLink/ribbonIcon/ribbon_big_ico_map.png';
import IconLink from '../img/activeLink/ribbonIcon/ribbon_big_ico_external_service.png';
import IconGuide from '../img/activeLink/ribbonIcon/ribbon_big_ico_guide.png';
import IconNaverWorks from '../img/ico_works_32.png';

import ga from '../utils/gaConnect';

export const useCustomTabData = () => {
  const { i18n } = useTranslation();
  const dispatch = useDispatch();
  const appDataSlice = useAppDataSliceSelector();

  const onOpenDialog = (dialogType, from, docType) => {
    dispatch(openDialog({ dialogType, arg: { from, docType } }));
  };

  const isSupportActiveLink =
    appDataSlice.productType === PRODUCT_TYPE.WITH_WHALE_SPACE &&
    (DOC_FORMAT_CONFIG_VALUES.sdk.documnetType === DOCUMENT_TYPE.HWP ||
      DOC_FORMAT_CONFIG_VALUES.sdk.documnetType === DOCUMENT_TYPE.WORD);

  // return isDevMode() &&

  const ACTIVELINK_TAB_MENU = [
    // {
    //   menuId: 'active_link_template_live_link',
    //   menuName: i18n.t('ActiveLink.LiveLink'),
    //   menuIcon: '',
    //   onClickRibbonMenu: () => {
    //     alert(i18n.t('ActiveLink.LiveLink'));
    //   }
    // },
    {
      menuId: 'active_link_template_insert_itt_contents',
      menuName: i18n.t('ActiveLink.InsertITTContents'),
      menuIcon: IconITTContents,
      onClickRibbonMenu: () => {
        ga.event({ category: '액티브링크', action: '메뉴열기', label: '톡톡콘텐츠' });
        onOpenDialog(DIALOG_TYPE.DIALOG_ACTIVELINK_INSERT_ITT_CONTENTS);
      }
    },
    // {
    //   menuId: 'active_link_template_vote',
    //   menuName: i18n.t('ActiveLink.Vote'),
    //   menuIcon: IconVote,
    //   onClickRibbonMenu: () => {
    //     onOpenDialog(DIALOG_TYPE.DIALOG_ACTIVELINK_VOTE);
    //   }
    // },
    // {
    //   menuId: 'active_link_template_share_opinion',
    //   menuName: i18n.t('ActiveLink.ShareOpinion'),
    //   menuIcon: IconShareOpinion,
    //   onClickRibbonMenu: () => {
    //     ga.event({ category: '액티브링크', action: '메뉴열기', label: '의견나누기' });
    //     onOpenDialog(DIALOG_TYPE.DIALOG_ACTIVELINK_SHAREOPINION);
    //   }
    // },
    {
      menuId: 'active_link_template_collaboration',
      menuName: i18n.t('ActiveLink.Collaboration'),
      menuIcon: IconCollaboration,
      onClickRibbonMenu: () => {
        ga.event({
          category: '액티브링크',
          action: '메뉴열기',
          label: '공동작업(캔버스)'
        });
        onOpenDialog(DIALOG_TYPE.DIALOG_ACTIVELINK_CANVAS);
      }
    },
    {
      menuId: 'active_link_insert_youtube',
      menuName: i18n.t('ActiveLink.YouTube'),
      menuIcon: IconYoutube,
      onClickRibbonMenu: () => {
        ga.event({ category: '액티브링크', action: '메뉴열기', label: '유튜브' });
        onOpenDialog(DIALOG_TYPE.DIALOG_ACTIVELINK_YOUTUBE);
      }
    },
    {
      menuId: 'active_link_insert_map',
      menuName: i18n.t('ActiveLink.Map'),
      menuIcon: IconMap,
      onClickRibbonMenu: () => {
        ga.event({ category: '액티브링크', action: '메뉴열기', label: '지도' });
        onOpenDialog(DIALOG_TYPE.DIALOG_ACTIVELINK_MAP);
      }
    },
    {
      menuId: 'active_link_insert_anything',
      menuName: i18n.t('ActiveLink.ExternalService'),
      menuIcon: IconLink,
      onClickRibbonMenu: () => {
        ga.event({
          category: '액티브링크',
          action: '메뉴열기',
          label: '외부서비스'
        });
        onOpenDialog(DIALOG_TYPE.DIALOG_ACTIVELINK_ANYTHING);
      }
    },
    {
      menuId: 'active_link_guide',
      menuName: i18n.t('FileMenu.Guide'),
      menuIcon: IconGuide,
      onClickRibbonMenu: () => {
        ga.event({
          category: '액티브링크',
          action: '메뉴열기',
          label: '사용가이드'
        });
        window.open(URLS.NOTION.ACTIVELINK_INSERT_GUIDE, '_blank');
      }
    }

    // {
    //   menuId: 'active_link_template_seating',
    //   menuName: i18n.t('ActiveLink.Seating'),
    //   menuIcon: IconSeatPosition,
    //   onClickRibbonMenu: () => {
    //     onOpenDialog(DIALOG_TYPE.DIALOG_ACTIVELINK_SEATING);
    //   }
    // },
    // {
    //   menuId: 'active_link_template_insert_image_grid',
    //   menuName: i18n.t('ActiveLink.InsertImageGrid'),
    //   menuIcon: IconImageLayout,
    //   onClickRibbonMenu: () => {
    //     onOpenDialog(DIALOG_TYPE.DIALOG_ACTIVELINK_INSERT_IMAGE_GRID);
    //   }
    // }
  ];

  const ACTIVELINK_TAB = isSupportActiveLink
    ? [
        {
          tabMenuId: 'active_link',
          tabMenuName: i18n.t('ActiveLink.ActiveLink'),
          ribbonGroups: [
            // {
            //   groupId: 'active_link_new_document_group',
            //   ribbonMenus: [
            //     {
            //       menuId: 'active_link_new_document',
            //       menuName: i18n.t('ActiveLink.NewDocument'),
            //       menuIcon: '',
            //       onClickRibbonMenu: () => {
            //         alert(i18n.t('ActiveLink.NewDocument'));
            //       }
            //     }
            //   ]
            // },
            // {
            //   groupId: 'active_link_load_document_group',
            //   ribbonMenus: [
            //     {
            //       menuId: 'active_link_load_document',
            //       menuName: i18n.t('ActiveLink.OpenDocument'),
            //       menuIcon: '',
            //       onClickRibbonMenu: () => {
            //         alert(i18n.t('ActiveLink.OpenDocument'));
            //       }
            //     }
            //   ]
            // },
            {
              groupId: 'active_link_template_group',
              ribbonMenus: ACTIVELINK_TAB_MENU
            }
          ]
        }
      ]
    : [];

  const isSupportExtStorage = appDataSlice.productType === PRODUCT_TYPE.WITH_WHALE_SPACE;

  const EXTERNAL_STORAGE_TAB = isSupportExtStorage
    ? [
        {
          tabMenuId: 'external_storage',
          tabMenuName: i18n.t('ExtStorageTab.TabTitle'),
          ribbonGroups: [
            {
              groupId: 'external_storage_naverworks_group',
              ribbonMenus: [
                {
                  menuId: 'external_storage_naverworks_image',
                  menuIcon: IconNaverWorks,
                  menuName: i18n.t('ExtStorageTab.NaverDriveImage'),
                  onClickRibbonMenu: () => {
                    ga.event({ category: '내 미디어', action: '웍스드라이브', label: '메뉴열기' });
                    dispatch(
                      openDialog({
                        dialogType: DIALOG_TYPE.DIALOG_NAVERWORKS_BROWSER,
                        arg: {
                          from: EDIT_FROM.FROM_RIBBORN_MENU,
                          navigatorType: NAVERWORKS_NAVIGATOR_TYPE.IMAGE
                        }
                      })
                    );
                  }
                }
              ]
            }
          ]
        }
      ]
    : [];

  return [/*...ACTIVELINK_TAB, ...EXTERNAL_STORAGE_TAB*/];
};
